import React, { Component, PropTypes } from 'react';
import { observer, inject } from 'mobx-react';
import { observable, autorun, action, toJS } from 'mobx';
import Spinner from '../../Spinner';
import DataTable from '../../DataTable';
import { Link } from 'react-router';

@inject('rawDataExportStore')
@observer
class RawDataExportList extends Component {
  static propTypes = {
    route: PropTypes.shape().isRequired,
    // params: PropTypes.shape({
    //   id: PropTypes.string.isRequired,
    // }).isRequired,
  };

  static contextTypes = {
    router: PropTypes.shape().isRequired,
    notify: PropTypes.shape().isRequired,
  };


  dispose;

  componentWillMount() {
    const { rawDataExportStore } = this.props;
    if (!rawDataExportStore.items.length && !rawDataExportStore.isLoading) rawDataExportStore.fetchItems();
  }

  columns = [
    { key: 'id', label: 'ID' },
    { key: 'name', label: 'Name' },
    { key: 'url', label: 'URL' },
    { key: 'raw_data_id', label: 'Raw Data Id' },
    { key: 'raw_data_end', label: 'Raw Data To' },
    { key: 'status', label: 'Enabled' },
  ];

  slug = 'export/raw-data-export';

  @action handleDelete = (idOrIds) => {
    const { notify } = this.context;
    this.props.rawDataExportStore.removeItems(idOrIds)
      .then(notify.success)
      .catch(notify.error);
  };

  render() {
    const { rawDataExportStore } = this.props;
    if (rawDataExportStore.isLoading) return <Spinner />;

    let data = rawDataExportStore.items.map(item => {
      return (Object.assign({}, item, {
        status: <i className='fa fa-circle' style={{ color: !!+item.status ? 'green' : 'red' }} data-toggle="tooltip" title={!!+item.status ? 'Enabled' : 'Disabled'} />,
      }));
    });

    return (
      <div>
        <DataTable
          data={data}
          slug={this.slug}
          columns={this.columns}
          onDelete={this.handleDelete}
          allowAdd
          allowEdit
          allowDelete
          resource='data-delivery'
          isLoading={rawDataExportStore.isLoading}
          actions={[{ label: 'Audit', link: '/export/raw-data-export/{id}/audit' }]}
        />
        {this.props.children}
      </div>
    );
  }
}

export default RawDataExportList;



// WEBPACK FOOTER //
// ./src/components/DataDelivery/RawDataExport/RawDataExportList.js